import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import {  useCallback, useState } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { useCreateDebounceHandler, useDebouncedCallback } from "../../../../common/hooks/use_debounced_callback";
import {  AcoePreventivasLista } from "../../domain/models/acoes_melhorias_lista";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { useDropDownLoader } from "../../../../common/hooks/use_dropdown_loader";
import { useNavigate, useParams } from "react-router";
import { useAcoesCorretivasFilters } from "../hooks/Qualidade_acoes_corretivas/filter";
import { useAcoesCorretivasPagination } from "../hooks/Qualidade_acoes_corretivas/pagination";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";

type LoadAcoesCorretivasListaFuncState = {
  IdAcaoQualidade?: number;
  page?: number;
  rowsPerPage?: number;
  tipoPesquisa?: number,
  status?: number,
  pesquisa?: string | number | Date,
  centroDeCusto?: number[],
  
};


export const useQualidadeAcoesCorretivasViewModel = () => {
  const {
    commons: { },
    reports: {getReportAcoesCorretivasUseCase},
    qualidade: { getAllListagemAcoesMelhoriasUseCase, deleteAcoesPreventivasUseCase }
   
  } = useDependencyInjection();

   const {
      loadCentroCustoDropDown,
    } = useDropDownLoader();

  const { status } = useParams();

  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [acoesCorretivasLista, setAcoesCorretivasLista] = useState<AcoePreventivasLista[]>([])
  const [selectedacoesCorretivas, setSelectedAcoesCorretivas] = useState<AcoePreventivasLista>()
  const [acoesCorretivasDeleteModal, setAcoesCorretivasDeleteModal] = useState<boolean>(false);
 
  const {pushErrorNotification, setCustomLoading } = usePageLoader();
  const debouncedRef = useCreateDebounceHandler(750);
    const navigate = useNavigate();

  const filters = useAcoesCorretivasFilters();
  const pagination = useAcoesCorretivasPagination();
  
  //#region Relatorio
    const [reportViewerState, startReportViewerProcess] = useReportViewer();
  //#endregion

  // #region Funções de carregamento

  const loadAcoesCorretivasListaState = useCallback(async (funcState?: LoadAcoesCorretivasListaFuncState) => {
      try {
        if(status !== undefined && status !== null) filters.status = Number(status);
        const filterID_Acoes_Corretivas = evaluateParamValue(funcState?.IdAcaoQualidade, filters.IdAcaoQualidade);
        const filteredPage = funcState?.page ?? pagination.page;
        const filteredRowsPerPage = funcState?.rowsPerPage ?? pagination.rowsPerPage;
        const filteredTipoPesquisa = funcState?.tipoPesquisa ?? filters.tipoPesquisa;
        const filteredPesquisa = funcState?.pesquisa ?? filters.pesquisa;
        const filteredStatus = funcState?.status ?? filters.status;
        const filteredCentroDeCusto = funcState?.centroDeCusto ?? filters.centroDeCusto;
        await getAllListagemAcoesMelhoriasUseCase.getAllListagemAcoesMelhorias(
          {
            IdAcaoQualidade: filterID_Acoes_Corretivas,Tipo: 1,  PesquisarPor: filteredTipoPesquisa, Pesquisar: String(filteredPesquisa ), status: filteredStatus, centroDeCusto: filteredCentroDeCusto,
          },
          filteredPage,
          filteredRowsPerPage
        );
        setAcoesCorretivasLista(getAllListagemAcoesMelhoriasUseCase.items);
        pagination.setRowsPerPage(getAllListagemAcoesMelhoriasUseCase.pageSize);
        pagination.setTotalItems(getAllListagemAcoesMelhoriasUseCase.totalItems);
       
      } catch (e: unknown) {
          throw new Error("Falha ao Ações Melhorias!");
      }
    }, [filters, getAllListagemAcoesMelhoriasUseCase, pagination, status]);


  //#endregion

  // #region useEffect
  usePageStartBootstrap(async () => {
    try {
      const jobs = [];
      await loadCentroCustoDropDown(list => useAcoesCorretivasFilters.setState({ centroDeCustoLista: list }));
      jobs.push(loadAcoesCorretivasListaState());
      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, 'Falha ao buscar dados da pagina!')[0]);
    }
  });

  const handleReload = useCallback(async () => {
    try {
      const jobs = [];
      setLoading(true);
      jobs.push(loadAcoesCorretivasListaState());
      
      await Promise.all(jobs);
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadAcoesCorretivasListaState, pushErrorNotification]);
  //#endregion

  // #region Eventos
  const handlePageChange = useCallback(async (page: number) => {
    try {
      setLoading(true);
      pagination.setPage(page + 1);;
      await loadAcoesCorretivasListaState({page: page + 1,});
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadAcoesCorretivasListaState, pagination, pushErrorNotification]);

  
  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
    try {
        setLoading(true);
        pagination.setPage(1);
        pagination.setRowsPerPage(rowsPerPage);
  
        await loadAcoesCorretivasListaState({ page: 1, rowsPerPage });
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadAcoesCorretivasListaState, pagination, pushErrorNotification]);

   const handleDeleteAcoesCorretivasModalOpenState = useCallback((IdAcaoQualidade: number | null, openState: boolean) => {
      if (openState) {
        if (IdAcaoQualidade && acoesCorretivasLista) {
          setSelectedAcoesCorretivas(acoesCorretivasLista.find(x => x.IdAcaoQualidade === IdAcaoQualidade));
        } else {
          setSelectedAcoesCorretivas(undefined);
        }
      }
      setAcoesCorretivasDeleteModal(openState);
    }, [acoesCorretivasLista]);
  

  const handleDeleteConfirmaAcoesCorretivas = useCallback(async () => {
    if (selectedacoesCorretivas) {
        try {
          setSaving(true);
          await deleteAcoesPreventivasUseCase.deleteAcoesPreventivas(selectedacoesCorretivas.IdAcaoQualidade);
          await loadAcoesCorretivasListaState();
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, 'Falha ao excluir informações!'));
        } finally {
          setSaving(false);
          setAcoesCorretivasDeleteModal(false);
        }
      }
    }, [deleteAcoesPreventivasUseCase, loadAcoesCorretivasListaState, pushErrorNotification, selectedacoesCorretivas]);

  

  //#endregion

  //#region Filtros
  const handleClearFilters = useCallback(async () => {
      try {
          setLoading(true);
          filters.clearFilters();
          pagination.setPage(1);
          await loadAcoesCorretivasListaState();
      } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, 'Falha ao buscar Ações Preventivas!'));
      } finally {
          setLoading(false);
      }
  }, [filters, pagination, loadAcoesCorretivasListaState, pushErrorNotification]);

  const handlePesquisaChange = useDebouncedCallback( debouncedRef,  (newValue: string | Date | number | null) => {
      useAcoesCorretivasFilters.getState().setPesquisa(newValue);
      
      if (newValue) {
        return async () => {
          try {
            setLoading(true);
            useAcoesCorretivasPagination.getState().setPage(1);
            await loadAcoesCorretivasListaState({ pesquisa: newValue, page: 1 });
          } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
          } finally {
            setLoading(false);
          }
        }
      } else {
        return async () => {
          try {
            setLoading(true);
            useAcoesCorretivasPagination.getState().setPage(1);
            await loadAcoesCorretivasListaState(); 
          } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
          } finally {
            setLoading(false);
          }
        }
      }
    }, 
    [ loadAcoesCorretivasListaState, pushErrorNotification, setLoading]
  );
  
  const handleTipoPesquisaChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useAcoesCorretivasFilters.getState().setTipoPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useAcoesCorretivasPagination.getState().setPage(1);
        await loadAcoesCorretivasListaState({ tipoPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadAcoesCorretivasListaState, pushErrorNotification]);

  const handleStatusChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
      useAcoesCorretivasFilters.getState().setStatus(newValue);
      return async () => {
      try {
        setLoading(true);
        useAcoesCorretivasPagination.getState().setPage(1);
        await loadAcoesCorretivasListaState({ status: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadAcoesCorretivasListaState, pushErrorNotification]);

  const handleCentroDeCustoChange = useDebouncedCallback(debouncedRef, (newValue: number[]) => {
      useAcoesCorretivasFilters.getState().setCentroDeCusto(newValue);
      return async () => {
        try {
          setLoading(true);
          useAcoesCorretivasPagination.getState().setPage(1);
          await loadAcoesCorretivasListaState({ centroDeCusto: newValue, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
        } finally {
          setLoading(false);
        }
      }
    }, [
      loadAcoesCorretivasListaState,
      pushErrorNotification,
    ]);

  //#endregion
  
  //#region Navegação
  const handleNewAcoesCorretivas = useCallback((tipo: "Corretiva" | "Preventivas", id: number | null) => {
    if(tipo === "Corretiva") navigate(`/AcoesCorretivas_Cadastro/${tipo}/${id}`)
    else if (tipo === "Preventivas") navigate(`/AcoesCorretivas_Cadastro/${tipo}`);

  }, [ navigate]);

  //#endregion

  //#region Relatorio
  const handleAcoesCorretivaaExportar = useCallback(async (IdAcaoQualidade: number) => {
    try {
      setLoading(true);
      await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportAcoesCorretivasUseCase.getReportAcoesCorretivas(IdAcaoQualidade, requiredMimeType),
      });
    } catch (e: unknown) {
      pushErrorNotification("Erro", processError(e, 'Falha ao gerar relatório de ações corretivas!'));
    } finally {
      setLoading(false);
      setCustomLoading(false);
    }
  }, [getReportAcoesCorretivasUseCase, pushErrorNotification, setCustomLoading, startReportViewerProcess]);

  //#endregion
  return {
    loading,
    saving,
    errorMessage,
    pagination,
    filters,
    acoesCorretivasLista,
    acoesCorretivasDeleteModal,
    reportViewerState,
    handleReload,
    handleRowsPerPageChange,
    handlePageChange,
    handleTipoPesquisaChange,
    handlePesquisaChange,
    handleClearFilters,
    handleStatusChange,
    handleCentroDeCustoChange,
    handleNewAcoesCorretivas,
    handleDeleteAcoesCorretivasModalOpenState, 
    handleDeleteConfirmaAcoesCorretivas,
    handleAcoesCorretivaaExportar
  }
}